/**
 * Общая логика обработки успешной авторизации
 * Используется как для Yandex, так и для Keycloak
 */

import { newName } from 'redux/slice/titleSlice';
import { setSidebarItem } from 'redux/slice/sidebarItemSlice';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import CommandService from 'services/CommandService';
import Strings from 'values/Strings';
import { privateRoutNames, publickRoutNames } from 'router';

/**
 * Обработка успешной авторизации
 * @param {Object} res - ответ от сервера с accessToken и userData
 * @param {Function} dispatch - Redux dispatch
 * @param {Function} navigate - React Router navigate
 * @param {Function} checkAuthAndReg - функция проверки и регистрации
 * @param {Function} notificationWarning - функция для показа предупреждений (опционально)
 */
export const handleSuccessfulAuth = async (res, dispatch, navigate, checkAuthAndReg, notificationWarning = null) => {
  // Сохраняем токены и данные пользователя
  localStorage.setItem('accessToken', res.accessToken);
  if (res?.userData) {
    localStorage.setItem('userData', res.userData);
  } else {
    localStorage.removeItem('userData');
  }

  if (!res.createAccount) {
    // Пользователь уже существует
    dispatch(newName(Strings.sidebarOccasion));
    
    const commandRes = await CommandService.checkCommand();
    if (commandRes) {
      localStorage.setItem('command', commandRes);
    } else {
      localStorage.removeItem('command');
    }

    const urlReg = localStorage.getItem('urlReg');
    if (urlReg) {
      checkAuthAndReg(JSON.parse(urlReg));
    } else {
      const occasionId = await localStorage.getItem('urlCreateTask');
      if (occasionId) {
        dispatch(setSidebarItem(Strings.createCase));
        navigate(`/private/${privateRoutNames.createCase}`);
      } else {
        dispatch(setSidebarItem(Strings.sidebarOccasion));
        navigate(`/${publickRoutNames.occasion}`);
      }
    }
    
    NotificationManager.success(
      Strings.notificationsAuth,
      Strings.notificationsSuccessTitle,
      2500
    );
  } else {
    // Новый пользователь - нужно заполнить профиль
    dispatch(setSidebarItem(Strings.sidebarProfile));
    navigate(`/private/${privateRoutNames.personalData}`);
  }
};

